import { render } from "./audit-log-group.vue?vue&type=template&id=97270bce"
import script from "./audit-log-group.vue?vue&type=script&lang=js"
export * from "./audit-log-group.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__